export default __webpack_public_path__ + "static/media/LandingPageVideo.623296ed.jpg";